export default function PopForm({close}){
    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
    
        formData.append("access_key", process.env.REACT_APP_FORM_KEY);
    
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData
        });
    
        const data = await response.json();
        // console.log(data)
        if (data.success) {
          alert("Thank you Our Team Will Contact You Soon...");
          close()
          event.target.reset();
        } else {
        //   console.log("Error", data);
            close()
          alert("Something Went Wrong. Feel Free To Call Us...")
        }
      };
    return(
        <div className="popContainer">
            <div className="popBG"/>
            <form className="popForm" onSubmit={onSubmit}>
                <h3 onClick={close}>X</h3>
                <h2>Let us reach you</h2>
                <div className="inputContainer">
                    <label>Name</label>
                    <input 
                        type="text"
                        name="name"
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Mobile Number</label>
                    <input 
                        type="text"
                        name="Mobile Number"
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Location</label>
                    <input 
                        type="text"
                        name="Location"
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Sale/Release</label>
                    <select
                        name="Sale/Release"
                        required>
                    <option hidden></option>
                    <option value={"Sale"}>Sale</option>
                    <option value={"Release"}>Release</option>
                    </select>
                </div>
                <button className="button-50 btnReverse submitBtn" type="submit">Book Now</button>
            </form>
        </div>
    )
}